import type { MutableRefObject } from 'react';

export const mutationObserver = ({
  nodeRef,
  measure,
  handleLoadImages,
}: {
  nodeRef: MutableRefObject<HTMLElement | null>;
  measure: () => void;
  handleLoadImages: () => void;
}) => {
  if (nodeRef.current) {
    measure?.();

    // Re-get all images each time mutation observer is exec
    handleLoadImages();
  }
};
